import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import Form from '../../components/forms/LegitimateForm';
import { saveLegitimate, deleteLegitimate, withRedirect } from '../../CroActions';
import {isLegitimate, isOfficialAdmin, isInternal} from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';

const selector = formValueSelector('legitimateForm');

const mapStateToProps = (state, { params, auth }) => ({
  breadcrumbsItems: [{ label: 'Oprávněné orgány' }, { label: 'Editace oprávněného orgánu' }],
  loginData: { name: selector(state, 'name') },
  url: `${auth.startUrl}/api/opravnene-organy/${params.id}`,
  disabled: isLegitimate(auth),
  canDelete: isOfficialAdmin(auth),
  officials: selector(state, 'officials') || [],
  allOfficials: selector(state, 'allOfficials') || false,
});

const onSubmit = (url) => withRedirect(saveLegitimate(url), `${url}/opravnene-organy`);

const mapDispatchToProps = (dispatch, props) => {
  const redirectUrl = props.auth.startUrl + '/opravnene-organy';
  const onDeleteRedirect = withRedirect(deleteLegitimate, redirectUrl);

  return {
    ...bindActionCreators({ onSubmit: onSubmit(props.auth.startUrl), breadcrumbs }, dispatch),
    onDelete: (note) => dispatch(onDeleteRedirect(props.params.id, note)),
    onShowHistory: (props.params.id && isInternal(props.auth))
      ? () => dispatch(push(`${props.auth.startUrl}/opravnene-organy/${props.params.id}/historie`))
      : null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
